import { Upload } from 'antd';
import styled from 'styled-components';

const { Dragger } = Upload;
export const DraggerWrapper = styled(Dragger)`
  .ant-upload {
    .ant-upload-btn {
      background-color: var(--light-link);
      padding: 16px;
    }
  }

  // Set when the dragger is showing a picked image instead of the
  // upload prompt (see BaseSettingsStep) - the inner .ant-upload-btn's own
  // padding/background otherwise still shows through as a border-like gap
  // around the image, since it's separate from this root's own padding
  // style prop.
  &.has-image .ant-upload-btn {
    padding: 0;
    background-color: transparent;
  }

  .upload-container {
    gap: 15px !important;

    .custom-btn.download-sample-btn {
      background-color: transparent;
      color: var(--link);

      &:hover {
        background-color: var(--light-link);
        color: var(--link);
      }
    }
  }
`;
